import Vue from 'vue';

function getMenuesFromUiConfig(uiConfig) {
    let menu = []
    if(!uiConfig) return menu;

    for (let i = 0; i < uiConfig.length; i++) {
        let item = uiConfig[i];
        if(!item.link || !item.link.startsWith("/")) continue;

        let itemModulo = getModuloEnMenu(menu, item.modulo);
        
        if(!itemModulo)
        {
            // creo el menú módulo
            itemModulo = createMenuItem(item.modulo, item.iconModulo?item.iconModulo: 'keyboard_arrow_up', 'keyboard_arrow_down', true, '')
            menu.push(itemModulo)
        }
        // agrego el item
        var itemMenu = createMenuItem(item.accionDescripcion, item.icon, item.iconAlt, false, item.link)
        itemModulo.children.push(itemMenu)
    }
    
    return menu;
}

function getTareasFrecuentesFromUiConfig(uiConfig) {
    let tareas = []
    if(!uiConfig) return tareas;

    for (let i = 0; i < uiConfig.length; i++) {
        let item = uiConfig[i];
        
        if(item.esFrecuente){
            var itemTarea = createTareaFrecuenteItem(item.accionDescripcion, item.icon, [{title: "Lanzar", link: item.link} ])
            tareas.push(itemTarea)
        }
    }
    
    return tareas;
}


function getModuloEnMenu(menues, nombreModulo){
    for (let i = 0; i < menues.length; i++) {
        if(menues[i].title == nombreModulo)
            return menues[i];
    }
    return null;
}

function createMenuItem(title, icon, iconalt, model, link){
    let item = {
        title: title,
        icon: icon,
        'icon-alt': iconalt,
        model: model,
        link : link,
        value: false
    }
    if(model)
        item.children = []

    return item;
}


function createTareaFrecuenteItem(title, icon, acciones){
    let item = {
        title: title,
        icon: icon,        
        acciones: acciones
    }

    return item;
}

export {
    getMenuesFromUiConfig,
    getTareasFrecuentesFromUiConfig
  }
  